import { render, staticRenderFns } from "./Sermon.vue?vue&type=template&id=08b95664&scoped=true"
import script from "./Sermon.vue?vue&type=script&lang=js"
export * from "./Sermon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b95664",
  null
  
)

export default component.exports